module.exports = __webpack_public_path__ + "static/media/saas7.200943bc.jpg";